import { capitalize } from '@/utils';

const baseActions = {
  clearItems({ commit }) {
    commit('CLEAR_ITEMS');
  },
  deleteItem({ commit, dispatch, state }, item) {
    return dispatch('delete', item).then(() => {
      commit('DELETE_ITEM', item);
      commit('DELETE_PAGINATED_ITEM', item);
      commit('SET_TOTAL_ITEM_COUNT', state.totalItemsCount - 1);
    });
  },
  getItem({ commit, dispatch }, params) {
    commit('SET_LOADING', true);
    const dontSave = params.options && params.dontSave;
    let fetchAppend = '';

    const identifier = {};

    const selector = params.selector;
    if (Object.keys(selector).length === 1) {
      const key = Object.keys(selector)[0];
      if (!key) {
        throw new Error('Selector is invalid');
      }
      if (key !== 'id') {
        fetchAppend = 'By' + capitalize(Object.keys(selector)[0]);
      }
      identifier[key] = selector[key];
    } else {
      throw new Error('Selector count is not equal to 1 ');
    }
    return dispatch('fetchOne' + fetchAppend, { ...identifier, params })
      .then(response => {
        const dto = response.data;
        return dispatch('transformDto', dto).then(item => {
          if (!dontSave) {
            commit('UPSERT_ITEM', item);
          }
          commit('SET_LOADING', false);
          return item;
        });
      })
      .catch(() => {
        commit('SET_LOADING', false);
      });
  },
  getItems(store, params) {
    const { commit, getters, rootGetters, dispatch } = store;
    const pageVersion = rootGetters['pageVersion'];
    commit('SET_LOADING', true);
    return dispatch('fetchList', params)
      .then(response => {
        if (getters['getVersion'] < pageVersion) {
          // Force clear if page has been changed since last load
          dispatch('clearItems');
        }
        for (const dto of response.data.items) {
          dispatch('transformDto', dto).then(item => {
            commit('UPSERT_ITEM', item);
          });
        }
        commit('SET_TOTAL_ITEM_COUNT', response.data.total);
        commit('SET_LOADING', false);
        commit('SET_VERSION', pageVersion);
      })
      .catch(() => {
        commit('SET_LOADING', false);
      });
  },
  getPaginatedItems({ commit, dispatch }, params) {
    commit('SET_LOADING', true);
    return dispatch('fetchList', params)
      .then(response => {
        for (const dto of response.data.items) {
          dispatch('transformDto', dto).then(item => {
            commit('UPSERT_PAGINATED_ITEM', item);
          });
        }
        commit('SET_TOTAL_ITEM_COUNT', response.data.total);
        commit('SET_LOADING', false);
      })
      .catch(() => {
        commit('SET_LOADING', false);
      });
  },
  persistItem({ commit, dispatch, state }, item) {
    commit('SET_LOADING', true);
    if (item.id) {
      return dispatch('update', item)
        .then(() => {
          commit('UPSERT_ITEM', item);
          commit('SET_LOADING', false);
        })
        .catch(error => {
          commit('SET_LOADING', false);
          return Promise.reject(error);
        });
    } else {
      return dispatch('create', item)
        .then(response => {
          const dto = response.data;
          return dispatch('transformDto', dto).then(item => {
            commit('UPSERT_ITEM', item);
            commit('SET_TOTAL_ITEM_COUNT', state.totalItemsCount + 1);
            commit('SET_LOADING', false);
            return item;
          });
        })
        .catch(error => {
          commit('SET_LOADING', false);
          return Promise.reject(error);
        });
    }
  },
  replaceItems({ commit, dispatch }, params) {
    commit('CLEAR_ITEMS');
    return dispatch('getItems', params);
  },
  replacePaginatedItems({ commit, dispatch }, params) {
    commit('CLEAR_PAGINATED_ITEMS');
    return dispatch('getPaginatedItems', params);
  }
};

export default baseActions;
